(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atom-details"] && !Shopify.designMode) return;
  try {
    function getScrollParent(el) {
    let node = el.parentElement;
    while (node) {
      if (node.scrollHeight > node.clientHeight) {
        var style = getComputedStyle(node);
        if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  document.querySelectorAll('details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;

      // Wait for the content to render
      requestAnimationFrame(function () {
        var scrollable = getScrollParent(details);
        if (!scrollable) return;

        // Scroll so the bottom of the details content is visible
        var detailsRect = details.getBoundingClientRect();
        var scrollableRect = scrollable.getBoundingClientRect();
        var overflowBottom = detailsRect.bottom - scrollableRect.bottom;

        if (overflowBottom > 0) {
          scrollable.scrollBy({ top: overflowBottom, behavior: 'smooth' });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atom-header-burger"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('[data-menu-toggle]');
    if (!btn) return;

    var icon = btn.querySelector('.burger-icon') || document.querySelector('.burger-icon');
    if (!icon) return;

    var top = icon.querySelector('.burger-line--top');
    var mid = icon.querySelector('.burger-line--mid');
    var bot = icon.querySelector('.burger-line--bot');
    var vert = icon.querySelector('.burger-line--vert');

    var opts = { duration: 1300, easing: 'ease-in-out', fill: 'both' };

    var anims = [
      top.animate(
        [
          { transform: 'rotate(0deg)', offset: 0 },
          { transform: 'rotate(90deg)', offset: 0.333 },
          { transform: 'translate(0, 0) rotate(90deg)', offset: 0.5 },
          { transform: 'translate(0, 6px) rotate(90deg) scaleX(0)', offset: 0.666 },
          { transform: 'translate(0, 6px) rotate(90deg) scaleX(0)', offset: 1 },
        ],
        opts,
      ),
      mid.animate(
        [
          { transform: 'rotate(0deg)', offset: 0 },
          { transform: 'rotate(90deg)', offset: 0.333 },
          { transform: 'rotate(90deg)', offset: 0.666 },
          { transform: 'rotate(45deg)', offset: 1 },
        ],
        opts,
      ),
      bot.animate(
        [
          { transform: 'rotate(0deg)', offset: 0 },
          { transform: 'rotate(90deg)', offset: 0.333 },
          { transform: 'translate(0, 0) rotate(90deg)', offset: 0.5 },
          { transform: 'translate(0, 6px) rotate(90deg) scaleX(0)', offset: 0.666 },
          { transform: 'translate(0, 6px) rotate(90deg) scaleX(0)', offset: 1 },
        ],
        opts,
      ),
      vert.animate(
        [
          { opacity: 0, transform: 'rotate(0deg)', offset: 0 },
          { opacity: 0, transform: 'rotate(0deg)', offset: 0.666 },
          { opacity: 1, transform: 'rotate(+45deg)', offset: 1 },
        ],
        opts,
      ),
    ];

    // Set initial state
    anims.forEach(function (a) {
      a.pause();
      a.currentTime = 0;
    });

    var menuDetails = document.querySelector('[data-header-menu-details]');
    if (!menuDetails) return;

    var mdQuery = window.matchMedia('(min-width: 768px)');

    // Reset animation to closed state when resizing to desktop.
    mdQuery.addEventListener('change', function (e) {
      if (e.matches) {
        anims.forEach(function (a) {
          a.pause();
          a.currentTime = 0;
        });
      }
    });

    // Burger is the sole toggle trigger. stopPropagation prevents the parent
    // <summary> from firing the native details toggle on top of this.
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      menuDetails.toggleAttribute('open');
    });

    // Drive animation from the details toggle event, not from the click.
    menuDetails.addEventListener('toggle', function () {
      if (mdQuery.matches) return;
      anims.forEach(function (a) {
        a.playbackRate = menuDetails.open ? 1 : -1;
        a.play();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const overlay = drawer.querySelector('[data-cart-drawer-overlay]');
    const panel = drawer.querySelector('[data-cart-drawer-panel]');
    const body = drawer.querySelector('[data-cart-drawer-body]');
    const footer = drawer.querySelector('[data-cart-drawer-footer]');
    const shipping = drawer.querySelector('[data-cart-drawer-shipping]');
    const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.remove('pointer-events-none');
      overlay.classList.remove('opacity-0', 'pointer-events-none');
      panel.classList.remove('translate-x-full');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      panel.classList.add('translate-x-full');
      overlay.classList.add('opacity-0', 'pointer-events-none');
      setTimeout(function () {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.classList.add('pointer-events-none');
        document.documentElement.style.overflow = '';
      }, 300);
    }
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* Refresh drawer content via Section Rendering API */
    function refresh() {
      fetch(routeRoot + '?sections=cart-drawer')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBody = doc.querySelector('[data-cart-drawer-body]');
          var newFooter = doc.querySelector('[data-cart-drawer-footer]');
          var newSubtotal = doc.querySelector('[data-cart-drawer-subtotal]');
          var newShipping = doc.querySelector('[data-cart-drawer-shipping]');
          if (newBody && body) body.innerHTML = newBody.innerHTML;
          if (newShipping && shipping) shipping.innerHTML = newShipping.innerHTML;
          if (footer && newFooter) {
            footer.innerHTML = newFooter.innerHTML;
            footer.className = newFooter.className;
          }
          /* Update header cart count badge */
          var badge = document.querySelector('[data-cart-count]');
          var newBadge = doc.querySelector('[data-cart-count]');
          if (badge && newBadge) badge.textContent = newBadge.textContent;
          bindQuantityButtons();
        });
    }
    /* Quantity change via Cart AJAX API */
    function updateQuantity(line, quantity) {
      fetch(routeRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function () {
        refresh();
      });
    }
    function bindQuantityButtons() {
      drawer.querySelectorAll('[data-cart-item]').forEach(function (item) {
        var line = parseInt(item.dataset.line, 10);
        var qtyEl = item.querySelector('[data-cart-item-quantity]');
        var minus = item.querySelector('[data-cart-quantity-minus]');
        var plus = item.querySelector('[data-cart-quantity-plus]');
        if (minus) {
          minus.onclick = function () {
            var qty = parseInt(qtyEl.textContent, 10);
            updateQuantity(line, Math.max(0, qty - 1));
          };
        }
        if (plus) {
          plus.onclick = function () {
            var qty = parseInt(qtyEl.textContent, 10);
            updateQuantity(line, qty + 1);
          };
        }
      });
    }
    /* Close on overlay click and close button */
    overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });
    /* Open triggers */
    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        refresh();
        open();
      });
    });
    /* Intercept add-to-cart forms */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            refresh();
            open();
          });
      }
    });
    bindQuantityButtons();
    /* Expose for external use */
    window.cartDrawer = { open: open, close: close, refresh: refresh };
  })();
  } catch(e) { console.error(e); }
})();

})();
